import { execSync } from 'node:child_process'

export interface GitRepoInfo {
  remote: string // owner/repo format
  branch: string
  remoteUrl: string
}

/**
 * Detect the current git repository information.
 * Returns null if not in a git repo or if detection fails.
 */
export function detectGitRepo(): GitRepoInfo | null {
  try {
    // Get git remote URL
    const remoteUrl = execSync('git remote get-url origin', {
      encoding: 'utf-8',
      stdio: ['pipe', 'pipe', 'pipe'],
    }).trim()

    // Parse remote URL to get owner/repo
    const repoFullName = parseGitRemoteUrl(remoteUrl)
    if (!repoFullName) {
      return null
    }

    // Get current branch
    const branch = execSync('git rev-parse --abbrev-ref HEAD', {
      encoding: 'utf-8',
      stdio: ['pipe', 'pipe', 'pipe'],
    }).trim()

    return {
      remote: repoFullName,
      branch,
      remoteUrl,
    }
  } catch {
    // Not in a git repo or git not available
    return null
  }
}

/**
 * Parse a git remote URL to extract the owner/repo format.
 * Handles both SSH and HTTPS URLs.
 */
export function parseGitRemoteUrl(remoteUrl: string): string | null {
  // Handle SSH URLs: git@github.com:owner/repo.git
  const sshPattern = /git@github\.com:([^/]+\/[^/]+?)(?:\.git)?$/
  const sshMatch = sshPattern.exec(remoteUrl)
  if (sshMatch) {
    return sshMatch[1]
  }

  // Handle HTTPS URLs: https://github.com/owner/repo.git
  const httpsPattern = /https:\/\/github\.com\/([^/]+\/[^/]+?)(?:\.git)?$/
  const httpsMatch = httpsPattern.exec(remoteUrl)
  if (httpsMatch) {
    return httpsMatch[1]
  }

  return null
}
